/**
 * @group Components
 * @summary <blockquote>StopIcon icon component.</blockquote>
 * @example
 * ```tsx
 * <StopIcon />
 * ```
 */
export const StopIcon = ({ size = 16 }: { size?: number }) => {
        return (
          <svg
            height={size}
            viewBox="0 0 16 16"
            width={size}
            style={{ color: 'currentcolor' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 3H13V13H3V3Z"
              fill="currentColor"
            />
          </svg>
        );
      };